import { jsx as i } from "react/jsx-runtime";
import { c as s } from "react/compiler-runtime";
import { Stepper as f } from "@mui/material";
import { forwardRef as l } from "react";
const d = l((t, m) => {
  const r = s(7);
  let e, o;
  r[0] !== t ? ({
    children: e,
    ...o
  } = t, r[0] = t, r[1] = e, r[2] = o) : (e = r[1], o = r[2]);
  let p;
  return r[3] !== e || r[4] !== o || r[5] !== m ? (p = /* @__PURE__ */ i(f, { ref: m, ...o, children: e }), r[3] = e, r[4] = o, r[5] = m, r[6] = p) : p = r[6], p;
});
export {
  d as Stepper
};
